import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [login, setLogin] = useState({ isLogin: false, token: null, user: {} });
  const [stateTwo, setStateTwo] = useState("State Two");
  const [stateThree, setStateThree] = useState(0);
  const [appData, setAppData] = useState({});
  const [ads, setAds] = useState([]);
  const [remoteScreen, setRemoteScreen] = useState({});

  return (
    <AppContext.Provider
      value={{
        login,
        setLogin,
        stateTwo,
        setStateTwo,
        stateThree,
        setStateThree,
        setAppData,
        appData,
        ads, setAds,
        remoteScreen, setRemoteScreen
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
